import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { InfoService } from '../info.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
  providers: [ InfoService ]
})
export class BlogComponent extends BaseComponent implements OnInit {

  @ViewChild("header", {static: false}) header;

  constructor(private infoService: InfoService) {
    super();
  }

  ngOnInit() {
  

  }

}
